<template>
    <!-- The whole Card hides while experiencia is checked (same rule the
         inner checks already use): an experience event has no abonados
         section — leaving the Card mounted renders an empty blue header. -->
    <Card
        v-if="!localData.experiencia"
        icon="fas fa-users"
        bg-color="tw:bg-blue-600"
        title-color="white"
        :title="'Abonados'"
        padding="0"
    >
        <div class="tw:p-6 tw:space-y-4">
            <template v-if="!localData.experiencia">
                <ToggleSwitch
                    :value="localData.cerrar_butacas_abonados"
                    @input="val => set(localData, 'cerrar_butacas_abonados', val)"
                    variant="primary"
                    id="customCheckbox2"
                >
                    {{ 'Cerrar las butacas de los abonados' }}
                    <Tooltip
                        :text="'Se cierran las butacas de los abonados, ningún usuario pueda elegir la localidad del abonado. En el dia del abonado, Solo el abonado podrá adquirir la localidad.'"
                        variant="success"
                        class="tw:normal-case"
                    />
                </ToggleSwitch>

                <template v-if="localData.cerrar_butacas_abonados">
                    <div ref="cerrarButacasSection" class="tw:ml-6 tw:space-y-3">
                        <ToggleSwitch
                            :value="localData.cerrar_butacas_abonados_no_confirmados"
                            @input="val => set(localData, 'cerrar_butacas_abonados_no_confirmados', val)"
                            variant="primary"
                            id="customCheckbox22"
                        >
                            {{ 'Cerrar las butacas de los abonados reservados' }}
                            <Tooltip
                                :text="'Cierra también las butacas de los abonados que las tienen reservadas pero todavía no han confirmado, para que ningún otro usuario pueda elegirlas. Depende de «Cerrar las butacas de los abonados»: solo está disponible cuando esa opción está marcada.'"
                                variant="success"
                                class="tw:normal-case"
                            />
                        </ToggleSwitch>

                        <div v-if="tipos?.length" class="tw:mt-4">
                            <DescuentosAbonados
                                :evento="localData"
                                :tipos="tipos"
                                @updateEvento="datosEvento => Object.assign(localData, datosEvento)"
                            />
                        </div>
                    </div>
                </template>
            </template>

            <template v-if="!localData.experiencia">
                <div class="tw:border-t tw:border-gray-100"></div>

                <ToggleSwitch
                    :value="localData.descuento_abonado"
                    @input="val => set(localData, 'descuento_abonado', val)"
                    variant="success"
                    id="customCheckbox3"
                    data-cy="activar-dia-abonado"
                >
                    {{ 'Activar día del abonado' }}
                    <Tooltip
                        :text="diaAbonadoTooltip"
                        variant="success"
                        class="tw:normal-case"
                    />
                </ToggleSwitch>

                <ToggleSwitch
                    :value="localData.amigo_abonado"
                    @input="val => set(localData, 'amigo_abonado', val)"
                    variant="success"
                    id="customCheckboxAmigoAbonado"
                    data-cy="activar-amigo-abonado"
                >
                    {{ 'Activar descuentos para amig@s de los abonad@s' }}
                </ToggleSwitch>

                <ToggleSwitch
                    :value="localData.seccion"
                    @input="val => set(localData, 'seccion', val)"
                    variant="primary"
                    id="customCheckbox4"
                >
                    {{ 'El abonado solo podrá adquirir su entrada en la zona correspondiente al Abono. No podrá adquirir entradas en otras zonas diferentes al abono.' }}
                </ToggleSwitch>

                <ToggleSwitch
                    :value="localData.forzar_adyacentes"
                    @input="val => set(localData, 'forzar_adyacentes', val)"
                    variant="primary"
                    id="checkbox_forzar_adyacentes"
                >
                    {{ 'Forzar la compra de butacas adyacentes por secciones completas' }}
                </ToggleSwitch>
            </template>

            <!-- Conditional: descuento_abonado && !experiencia -->
            <div v-if="localData.descuento_abonado && !localData.experiencia" ref="diaAbonadoSection">
                <div class="tw:border-t tw:border-gray-100 tw:mb-4"></div>
                <div class="tw:space-y-2 tw:mb-4">
                    <div class="tw:flex tw:items-center tw:gap-2">
                        <label class="tw:text-gray-500 tw:m-0 tw:uppercase">
                            {{ 'Tiempo límite para el día del abonado' }}
                        </label>
                        <Tooltip
                            :text="'Una vez transcurrido el día y la hora indicada, se liberan los asientos de los abonados que no hayan activado/adquirido su entrada y cualquier usuario podrá adquirir la butaca liberada. El abonado si accede y su butaca está ocupada, podrá elegir otra butaca.'"
                            variant="success"
                            class="tw:normal-case"
                        />
                    </div>
                    <div class="tw:flex tw:flex-col tw:w-full tw:gap-2">
                        <div class="tw:w-full ">
                            <BaseDateTimeInput
                                :label="'Fecha límite'"
                                name="limite_dia_abonado"
                                :value="localData.limite_dia_abonado"
                                :min="minFechaLimite"
                                :max="maxFechaLimite"
                                rules="required"
                                @input="val => set(localData, 'limite_dia_abonado', val)"
                            />
                        </div>
                    </div>
                </div>

                <div class="tw:grid tw:grid-cols-1 tw:md:grid-cols-2 tw:gap-4">
                    <div class="tw:flex tw:flex-col tw:justify-start">
                        <div class="tw:flex tw:items-start tw:gap-2 tw:mb-2">
                            <label class="tw:text-gray-500 tw:mb-1 tw:uppercase tw:m-0">
                                {{ 'Tipos de abonos que pueden comprar entrada' }}
                            </label>
                            <Tooltip
                                :text="'Si no asignas ninguno, se permite la compra a todos los tipos'"
                                variant="success"
                                class="tw:normal-case"
                            />
                        </div>
                        <BaseMultiselect
                            :label="'Seleccionar tipos'"
                            name="tipos_abonos_ids"
                            :value="localData.tipos_abonos_ids"
                            :options="tipos"
                            label-key="descripcion"
                            :multiple="true"
                            @input="val => {
                                // Guardamos OBJETOS completos (no solo IDs) para
                                // que el backend reciba el formato que espera
                                // (master usaba v-model + track-by que guarda
                                // objetos). BaseMultiselect's selectedOptions
                                // ahora maneja objetos via `some` con
                                // comparación por id, ver BaseMultiselect.vue.
                                const ids = Array.isArray(val) ? val : (val ? [val] : []);
                                set(localData, 'tipos_abonos_ids', tipos.filter(t => ids.includes(t.id)));
                            }"
                        />
                    </div>

                    <div>
                        <div class="tw:flex tw:items-start tw:gap-2 tw:mb-2">
                            <label class="tw:text-gray-500 tw:mb-1 tw:uppercase">
                                {{ 'Tipos de abonos que pueden acceder sin comprar entrada' }}
                            </label>
                            <Tooltip
                                :text="'Si no asignas ninguno, se permite el acceso a todos los tipos'"
                                variant="success"
                                class="tw:normal-case"
                            />
                        </div>
                        <BaseMultiselect
                            :label="'Seleccionar tipos'"
                            name="tipos_abonos_permitidos_ids"
                            :value="localData.tipos_abonos_permitidos_ids"
                            :options="tipos"
                            label-key="descripcion"
                            :multiple="true"
                            @input="val => {
                                // Guardamos OBJETOS completos (no solo IDs) para
                                // que el backend reciba el formato que espera
                                // (master usaba v-model + track-by que guarda
                                // objetos). BaseMultiselect's selectedOptions
                                // ahora maneja objetos via `some` con
                                // comparación por id, ver BaseMultiselect.vue.
                                const ids = Array.isArray(val) ? val : (val ? [val] : []);
                                set(localData, 'tipos_abonos_permitidos_ids', tipos.filter(t => ids.includes(t.id)));
                            }"
                        />
                    </div>
                </div>
            </div>

            <!-- Conditional: descuento_abonado || amigo_abonado -->
            <div v-if="localData.descuento_abonado || localData.amigo_abonado" ref="rangoAbonadoSection">
                <div class="tw:border-t tw:border-gray-100 tw:mb-4"></div>
                <div class="tw:space-y-2 tw:mb-6">
                    <div class="tw:flex tw:items-start tw:gap-2">
                        <label class="tw:text-gray-500 tw:mb-1 tw:uppercase">
                            {{ 'Rango de abonado' }}
                        </label>
                        <Tooltip
                            :text="'Define qué números de abonado pueden comprar entradas (no es una cantidad, sino el rango de números asignado a cada abonado por el club). Por ejemplo, si indicas Desde 1300 Hasta 4500, el abonado nº 1299 NO podrá comprar y el nº 1300 sí; el nº 4501 tampoco. Si no indicas ningún rango, se aplica por defecto a TODOS LOS ABONADOS. (Día del abonado y Amig@)'"
                            variant="success"
                            class="tw:normal-case"
                        />
                    </div>
                    <div class="tw:flex tw:flex-col tw:w-full tw:gap-2">
                        <div class="tw:grid tw:grid-cols-1 tw:md:grid-cols-2 tw:gap-4 tw:w-full">
                            <BaseInputNumber
                                name="abonado_desde"
                                :label="'Desde'"
                                :value="localData.abonado_desde"
                                :min="0"
                                rules="rangoAbonadoDesde"
                                @input="val => set(localData, 'abonado_desde', val)"
                            />
                            <BaseInputNumber
                                name="abonado_hasta"
                                :label="'Hasta'"
                                :value="localData.abonado_hasta"
                                :min="0"
                                rules="rangoAbonadoHasta"
                                @input="val => set(localData, 'abonado_hasta', val)"
                            />
                        </div>
                    </div>
                </div>
                <div class="tw:grid tw:grid-cols-1 tw:md:grid-cols-2 tw:gap-4">
                    <div>
                        <BaseInputNumber
                            id="n_acompanantes_min"
                            name="n_acompanantes_min"
                            :label="'Nº mínimo de acompañantes'"
                            :value="localData.n_acompanantes_min"
                            :min="0"
                            rules="acompanantesMin"
                            @input="val => set(localData, 'n_acompanantes_min', val)"
                        />
                        <small class="tw:text-xs tw:text-gray-500 tw:leading-snug tw:mt-1 tw:text-end tw:block">(Día del abonado y Amig@)</small>
                    </div>
                    <div>
                        <BaseInputNumber
                            id="n_acompanantes"
                            name="n_acompanantes"
                            :label="'Nº máximo de acompañantes'"
                            :value="localData.n_acompanantes"
                            :min="0"
                            rules="acompanantesMax"
                            @input="val => set(localData, 'n_acompanantes', val)"
                        />
                        <small class="tw:text-xs tw:text-end tw:text-gray-500 tw:leading-snug tw:mt-1 tw:block">(Día del abonado y Amig@)</small>
                    </div>
                </div>
            </div>

            <!-- Conditional: amigo_abonado -->
            <div v-if="localData.amigo_abonado" ref="amigoAbonadoSection">
                <div class="tw:border-t tw:border-gray-100 tw:mb-4"></div>
                <div class="tw:flex tw:flex-col tw:md:flex-row tw:md:gap-4 tw:mb-5">
                    <div class="tw:w-full">
                        <div>
                            <label class="tw:text-gray-500 tw:mb-2 tw:uppercase">
                                {{ 'Tipos de abonos no permitidos' }}
                            </label>
                            <BaseMultiselect
                                :label="'Seleccionar tipos'"
                                name="amigos_tipos_abonos_ids"
                                :value="(localData.amigos_tipos_abonos_ids || []).map(t => t.id)"
                                :options="tipos"
                                label-key="descripcion"
                                :multiple="true"
                                rules="amigosDescuentosRequiereAmigosTipos"
                                @input="onTiposChange"
                            />
                            <small class="tw:text-xs tw:text-gray-500 tw:leading-snug tw:mt-1 tw:block tw:text-end">
                                {{ '(Amig@s de los abonad@s)' }}
                            </small>

                        </div>
                    </div>
                    <div class="tw:w-full">
                        <div>
                            <label class="tw:text-gray-500 tw:mb-2 tw:uppercase">
                                {{ 'Precios no permitidos' }}
                            </label>
                            <BaseMultiselect
                                :label="'Seleccionar precios'"
                                name="amigos_descuentos_abonos_ids"
                                :value="(localData.amigos_descuentos_abonos_ids || []).map(d => d.id)"
                                :options="descuentos"
                                label-key="descripcion"
                                :multiple="true"
                                rules="amigosTiposRequiereAmigosDescuentos"
                                @input="onDescuentosChange"
                            />
                            <small class="tw:text-xs tw:text-gray-500 tw:leading-snug tw:mt-1 tw:text-end tw:block">
                                {{ '(Amig@s de los abonad@s)' }}
                            </small>
                        </div>
                    </div>
                </div>
                <div class="tw:space-y-2">
                    <BaseInputNumber
                        id="n_max_pedidos"
                        name="n_max_pedidos"
                        :label="'Número máximo de pedidos'"
                        :value="localData.n_max_pedidos"
                        :min="0"
                        @input="val => set(localData, 'n_max_pedidos', String(val))"
                    />
                </div>
            </div>
        </div>
    </Card>
</template>

<script setup>
    import { inject, set, ref, computed } from 'vue';
    import { useScrollOnToggle } from '@/composables/common/useScrollOnToggle';
    import Card from '@/modules/admin/ui/Card.vue';
    import ToggleSwitch from '@/modules/admin/ui/ToggleSwitch.vue';
    import Tooltip from '@/modules/admin/ui/Tooltip.vue';
    import BaseInputNumber from '@/modules/admin/ui/BaseInputNumber.vue';
    import BaseMultiselect from '@/modules/admin/ui/BaseMultiselect.vue';
    import BaseDateTimeInput from '@/modules/admin/ui/BaseDateTimeInput.vue';
    import DescuentosAbonados from '@/modules/admin/eventos/components/DescuentosAbonados.vue';

    const localData = inject('eventoFormData');

    // Min del input de Tiempo límite = ahora (en formato "YYYY-MM-DDTHH:mm"
    // que es lo que acepta `<input type="datetime-local">`). El computed
    // se evalúa una sola vez al montar el componente — si el usuario
    // tiene el form abierto horas, el min se queda en el "ahora" inicial
    // (limitación aceptable, evita timers).
    const minFechaLimite = computed(() => new Date().toISOString().slice(0, 16));
    // Max = end_event_date si está definida. `undefined` cuando no hay
    // fecha de fin, para que BaseDateTimeInput no bindee el atributo
    // (el bug `min="null"` que arreglamos antes).
    const maxFechaLimite = computed(() => localData.end_event_date || undefined);

    // Textos de los tooltips de la sección Abonados. Coinciden con los `<small>`
    // que tenía el FormEvento legacy de master antes del refactor de Composition API.
    const diaAbonadoTooltip = 'El abonado tendrá que activar / adquirir su entrada tanto online como física. Esta modalidad es válida para entradas desde 0.00€. Si el abono no se activa, este no podrá acceder al recinto.';

    const props = defineProps({        tipos: { type: Array, default: () => [] },
                                       descuentos: { type: Array, default: () => [] }
    });

    // Extract multiselect handler to a method (avoids the Vue 2 quirk
    // where inline template arrows in @input can lose reactivity tracking).
    // Uses set() explicitly for the same reason.
    function onTiposChange(val) {
        const arr = Array.isArray(val) ? val : (val ? [val] : []);
        const ids = arr.filter(id => typeof id === 'number' && !isNaN(id));
        set(localData, 'amigos_tipos_abonos_ids', props.tipos.filter(t => ids.includes(t.id)));
    }

    function onDescuentosChange(val) {
        const arr = Array.isArray(val) ? val : (val ? [val] : []);
        const ids = arr.filter(id => typeof id === 'number' && !isNaN(id));
        set(localData, 'amigos_descuentos_abonos_ids', props.descuentos.filter(d => ids.includes(d.id)));
    }
    // Refs a las secciones condicionales que aparecen al activar cada check.
    // El composable se encarga de detectar el cambio false→true y hacer scrollIntoView.
    const cerrarButacasSection = ref(null);
    const diaAbonadoSection = ref(null);
    const rangoAbonadoSection = ref(null);
    const amigoAbonadoSection = ref(null);

    useScrollOnToggle(() => localData.cerrar_butacas_abonados, cerrarButacasSection);
    useScrollOnToggle(() => localData.descuento_abonado, diaAbonadoSection);
    useScrollOnToggle(() => localData.amigo_abonado, amigoAbonadoSection);

    // Cross-validation cliente (rango de abonado Desde/Hasta y acompañantes
    // min/max): se delega a custom rules de vee-validate registradas
    // globalmente en useEventForm.js (rangoAbonadoDesde, rangoAbonadoHasta,
    // acompanantesMin, acompanantesMax). Las rules se referencian por
    // nombre en `:rules` y vee-validate se encarga del error inline,
    // del atributo `data-validation-error=""` que usa scrollToFirstError,
    // y de bloquear el submit.
    </script>
